import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/search_24.svg.ts
import { svg } from "lit";
var search24Svg = svg`
<svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.25 19.5C15.8063 19.5 19.5 15.8063 19.5 11.25C19.5 6.69365 15.8063 3 11.25 3C6.69365 3 3 6.69365 3 11.25C3 15.8063 6.69365 19.5 11.25 19.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21 21L17.25 17.2501" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  search24Svg
};
//# sourceMappingURL=search_24.svg-7BVVC7QD.js.map
